import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators, ValidatorFn, AbstractControl, ValidationErrors  } from '@angular/forms';
// import { providerDef } from '@angular/core/src/view/provider';
import { Params, ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as $ from "jquery";
import { throwError } from 'rxjs';
import { catchError, first } from 'rxjs/operators';
import {Md5} from "ts-md5/dist/md5";
import { ConfirmPasswordValidator } from '../../components/validators/validators.component';
import { VerifyCodeService } from '../../components/verifycanvas/verifyCodeService';
import { AlertService } from '../../services/alert.service';
import { UserService } from '../../services/user.service';

@UntilDestroy()
@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {
  registerForm: FormGroup;
  errorId : String;
  errorMessage : String | null | undefined;
  submitted = false;
  loading = false;

  constructor(
    private route: ActivatedRoute,
    private formBuilder : FormBuilder,
    private userService: UserService,
    private alertService: AlertService,
    private verifyCodeService: VerifyCodeService,
    private readonly router: Router) {
  }
  
  
    get f() { return this.registerForm.controls; }

  ngOnInit() {
    this.registerForm = this.formBuilder.group({
      nickName: ['', Validators.required],
      username: ['', Validators.required],
      userEmail: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      password2: ['', [Validators.required, Validators.minLength(6)]],
      varifyCode: ['',[Validators.required, this.checkVerifyCode]]
  },{
    validators: ConfirmPasswordValidator('password','password2')
  }
  );

    this.route.queryParams.subscribe(queryParams => {
      this.errorId = queryParams.error;
    });

    if(this.errorId) {
      this.setErrorMessage(this.errorId);
    }
    
    this.refresh();
  }

   checkVerifyCode: ValidatorFn = (control: AbstractControl):  ValidationErrors | null => { 
     if(control.value=='') return null;

    if (!this.verifyCodeService.validate(control.value)) { 
      return { notSame: true };      
      }
    return null;
  };

  
  refresh() {
    this.verifyCodeService.init(document.getElementById('verifyCanvas'));
  }
 
  onSubmit() {
    this.submitted = true;
   

    // reset alerts on submit
    this.alertService.clear();

    // this.registerForm.setErrors(null);
    // console.log('sssssssssssss'+this.registerForm.setErrors(null));
    // console.log('sssssssssssss'+this.registerForm.valid);
    // console.log('sssssssssssss'+this.registerForm.invalid);
    // stop here if form is invalid
    if (this.registerForm.invalid) {
        return;
    }

    
    if (!this.verifyCodeService.validate($('#varifyCode').val())) { 
     return;
    }

    this.loading = true;
    this.oripd = this.registerForm.value['password'];
    console.log("1>>>"+this.registerForm.value['userEmail']);
    this.registerForm.value['password'] = this.md5(this.oripd);
    // console.log("2>>>"+this.registerForm.value['password']);
    this.userService.register(this.registerForm.value)
        .pipe(first())
        .subscribe(
            data => {
                this.alertService.success('注册成功!请登录邮箱进行用户确认！', true);
                this.router.navigate(['/login']);
            },
            (error) => {
                this.alertService.error(error.error.message);
                this.verifyCodeService.refresh();
                this.resetOriPwd();
                this.loading = false;
            });
}
private oripd;
private resetOriPwd(){
  this.registerForm.controls['varifyCode'].setValue('');
  this.registerForm.value['password'] = this.oripd;
}

  

  md5(pwd: string): string{
    // console.log('md5:'+Md5.hashStr(pwd).toString());
    return Md5.hashStr(pwd).toString();
  }

  setErrorMessage(errorId : String) {
    switch (errorId) {
      case '1': this.errorMessage = "用户名或者密码错误.";
    }
  }
} 
 

